import { UploadLogoComponent } from '../../../shared/components/uploadlogo/upload-logo.component';
import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewContainerRef} from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { MenuItem, ConfirmationService } from 'primeng/primeng';
import { Observable } from 'rxjs/Observable';

import { ConstantsService } from 'app/services/constants-service';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { ApplicationTypeConstants, WarmUpService } from 'app/services/warmup/warmup.service';
import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { SidebarTasksService } from 'app/services/sidebar-tasks.service';

import { ClientHeaderService } from './client-header.service';
import { OffboardClientComponent } from './offboardclient/offboard-client.component';
import { TaskStructureComponent } from 'app/task/taskstructure/task-structure.component';
import { ReviewCompanyComponent } from './reviewcompany/review-company.component';
import { RiskProfileComponent } from './riskprofile/risk-profile.component';
import { SystemDivisionComponent } from './systemdivision/system-division.component';
import { OrganisationDetailsComponent } from './organisationdetails/organisation-details.component';
import { ArchivalConfirmComponent } from 'app/admin/archival/archivalconfirm/archival-confirm.component';

import { formatDisplayDate } from 'app/shared/utils/date-format.util';
import { Organisation } from 'app/shared/models/organisation.model';
import { OrganisationDetails } from 'app/shared/models/org-details.model';
import { SystemDivision } from './systemdivision/system-division.model';
import { User } from 'app/shared/models/user.model';
import { OnBoardRequestModel } from './onboard-request.model';
import { OnBoardResponseModel } from './onboard-response.model';
import { WorkflowType } from './onboard-request.model';
import { TaskService } from 'app/task/task.service';
import {Subscription} from "rxjs";
import {Router} from '@angular/router';
import {CookieService} from "../../../services/cookie.service";
import {AuthenticationGuard} from '../../../services/authentication-guard.service';

@Component({
  selector: 'app-client-header',
  templateUrl: './client-header.component.html'
})

/**
 * Component for organisation/client header details.
 */
export class ClientHeaderComponent implements OnInit, OnDestroy {
  dialogRef: MdDialogRef<any>;
  organisationDetails: OrganisationDetails;
  isClient: boolean;
  canCompliance = false;
  canReview = false;
  isAdmin = false;
  selectedIndex = 0;
  private subscriptions = new Subscription();
  clientReviewEnabled = false;
  complianceCheckEnabled = false;

  // organisation
  orgName: string;
  sfi: String;
  registrationCode: string;
  incorporationDate: Date | null;
  isin: string;
  legalStructureName: string;
  stockExchangeName: string;
  stockExchangeValues: ApplicationValue[];

  //client specific
  accountManager: string;
  financeManager: string;
  startOfServices: Date | null;
  endOfServices: Date | null;
  statusName: String;
  statusDate: Date;
  reviewDate: Date;
  orgLogo = '';
  isWTT: String;

  systemDivisions: SystemDivision[];
  onBoardItems: MenuItem[];

  // Constructor method
  constructor(
    private clientHeaderService: ClientHeaderService,
    private sidebarTasksService: SidebarTasksService,
    private viewContainerRef: ViewContainerRef,
    private dialog: MdDialog,
    private warmUpService: WarmUpService,
    private authenticationGuard: AuthenticationGuard,
    private cdr: ChangeDetectorRef,
    private snackBarService: SnackBarService,
    private trackingService: TrackingService,
    private taskService: TaskService,
    private cookieService: CookieService,
    private router: Router,
    private confirmationService: ConfirmationService) {
      this.canCompliance = cookieService.get(ConstantsService.COOKIE_COMPLIANCE_OFFICER) === 'true';
      this.canReview = cookieService.get(ConstantsService.COOKIE_USER_ROLE)  !== 'READ';
      this.isAdmin = this.authenticationGuard.isAdminUser();
  }

  ngOnInit() {
    this.organisationDetails = new OrganisationDetails();
    this.clientHeaderService.onOrganisationDetailsEvent().subscribe(
      orgDetails => {
        this.organisationDetails = orgDetails;
        this.initializeHeaderData();
      }
    );

    this.setupControlValues('stockExchangeValues',
      (this.warmUpService.getApplicationValue(ApplicationTypeConstants.STOCK_EXCHANGE)));
  }

  setupControlValues(control, dropDownValues: any) {
    if (dropDownValues instanceof Observable) {
      dropDownValues.subscribe(
        response => {
          this.warmUpService.setApplicationTypeInLS(response);
          this[control] = response.values;
          this.cdr.detectChanges();
        }
      );
    } else {
      this[control] = dropDownValues;
    }
  }

  initializeHeaderData() {
    this.isClient = this.organisationDetails.clientVO !== null;
    if (this.isClient) {
      const accountManager = this.organisationDetails.clientVO.accountManagerVO;
      if (!accountManager) {
        this.accountManager = '< unassigned! >';
      } else {
        this.accountManager = accountManager.name === '' ? accountManager.loginId : accountManager.name;
      }

      const financeManager = this.organisationDetails.clientVO.financeManagerVO;
      if (financeManager !== null) {
        this.financeManager = financeManager.name === '' ? financeManager.loginId : financeManager.name;
      }
      this.statusName = this.organisationDetails.clientVO.statusName;
      this.statusDate = this.organisationDetails.clientVO.statusDate;
      this.reviewDate = this.organisationDetails.clientVO.reviewDate;
      this.startOfServices = this.organisationDetails.clientVO.startOfServices;
      this.endOfServices = this.organisationDetails.clientVO.endOfServices;
      this.isWTT = this.organisationDetails.clientVO.isWTT ? 'WTT' : 'WWFT';
    }
    this.sfi = this.organisationDetails.organisationVO.isSpecialFinancialInstitution ? 'Yes' : 'No';
    this.registrationCode = this.organisationDetails.organisationVO.registrationCode;
    this.incorporationDate = this.toDate(this.organisationDetails.organisationVO.incorporatedDate);
    this.isin = this.organisationDetails.organisationVO.isin;
    if (this.organisationDetails.organisationVO.legalStructureId != -1) {
      this.legalStructureName = (this.organisationDetails.organisationVO.legalStructureName) ?
        this.organisationDetails.organisationVO.legalStructureName : this.legalStructureName = "< value missing! >";
    }
    if (this.organisationDetails.organisationVO.stockExchangeId !== -1) {
      this.stockExchangeName = this.getStockExchangeName(this.organisationDetails.organisationVO.stockExchangeId);
    }
    this.orgName = this.organisationDetails.organisationVO.name;
    this.orgLogo = this.organisationDetails.organisationVO.logo;
  }

  updateHeaderDetails(response: Organisation) {
    this.orgName = response.name;
    this.incorporationDate = this.toDate(response.incorporatedDate);
    this.isin = response.isin;
    this.registrationCode = response.registrationCode;
    this.legalStructureName = response.legalStructureName;
    this.stockExchangeName = response.stockExchangeName;
    this.sfi = response.isSpecialFinancialInstitution ? 'Yes' : 'No';

    // update organisationVO
    this.organisationDetails.organisationVO.name = response.name;
    this.organisationDetails.organisationVO.isin = response.isin;
    // Convert string date to Date object for Organisation model (which accepts Date | string)
    this.organisationDetails.organisationVO.incorporatedDate = this.toDate(response.incorporatedDate);
    this.organisationDetails.organisationVO.registrationCode = response.registrationCode;
    this.organisationDetails.organisationVO.legalStructureId = response.legalStructureId;
    this.organisationDetails.organisationVO.legalStructureName = response.legalStructureName;
    this.organisationDetails.organisationVO.stockExchangeId = response.stockExchangeId;
    this.organisationDetails.organisationVO.stockExchangeName = response.stockExchangeName;
    this.organisationDetails.organisationVO.isSpecialFinancialInstitution = response.isSpecialFinancialInstitution;

    // update client(VO)
    if (this.isClient) {
      this.accountManager = response.accountManagerName;
      this.financeManager = response.financeManagerName;
      this.startOfServices = this.toDate(response.startOfService);
      this.endOfServices = this.toDate(response.endOfService);
      this.isWTT = response.isWTT ? 'WTT' : 'WWFT';
      // Update account manager (required field)
      if (this.organisationDetails.clientVO.accountManagerVO) {
        this.organisationDetails.clientVO.accountManagerVO.userId = response.accountManagerId;
        this.organisationDetails.clientVO.accountManagerVO.name = response.accountManagerName;
      }
      // Update finance manager (optional field - may be null)
      if (response.financeManagerId && response.financeManagerName) {
        // Initialize financeManagerVO if it doesn't exist
        if (!this.organisationDetails.clientVO.financeManagerVO) {
          this.organisationDetails.clientVO.financeManagerVO = new User();
        }
        this.organisationDetails.clientVO.financeManagerVO.userId = response.financeManagerId;
        this.organisationDetails.clientVO.financeManagerVO.name = response.financeManagerName;
      } else {
        // Clear finance manager if it was removed
        this.organisationDetails.clientVO.financeManagerVO = null;
      }
      // Convert string dates to Date objects for Client model
      const startOfServiceDate = this.toDate(response.startOfService);
      const endOfServiceDate = this.toDate(response.endOfService);
      this.organisationDetails.clientVO.startOfServices = startOfServiceDate;
      this.organisationDetails.clientVO.endOfServices = endOfServiceDate;
      this.organisationDetails.clientVO.isWTT = response.isWTT;
    }
  }

  updateDetailsPostOnboarding(onBoardingResponse: OnBoardResponseModel) {
    this.organisationDetails.organisationVO = onBoardingResponse.orgVO;
    this.organisationDetails.clientVO = onBoardingResponse.client;
    this.organisationDetails.executiveSummary = onBoardingResponse.executiveSummary;
    this.initializeHeaderData();

    // load new tasks post onboarding.
    this.sidebarTasksService.loadTasks();

    this.taskService.sendMessage('updateActiveWorkFlow');

  }

  openUpdateOrganisationDetails() {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(OrganisationDetailsComponent, config);
    this.dialogRef.componentInstance.organisationDetails = this.organisationDetails;
    this.dialogRef.componentInstance.isClient = this.isClient;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      if (result) {
        this.updateHeaderDetails(result);
      }
    });
  }

  openProcessStructureDialog() {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;
    this.dialogRef = this.dialog.open(TaskStructureComponent, config);
    this.dialogRef.componentInstance.entityId = this.organisationDetails.organisationVO.id;
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }

  openUpdateReviewDateDialog() {
    if (this.organisationDetails.clientVO.reviewDate == null) {
      let response = {
        'message': 'To set a review date, please create a risk profile first.'
      };
      this.callSnackBarService(response, '', '');
      return;
    }

    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(ReviewCompanyComponent, config);
    this.dialogRef.componentInstance.organisationDetails = this.organisationDetails;
    this.dialogRef.afterClosed().subscribe(newDate => {
      if (newDate) {
        this.organisationDetails.clientVO.reviewDate = newDate;
        this.reviewDate = newDate;
      }
      this.dialogRef = null;
    });
  }

  onComplianceReview() {
    this.complianceCheckEnabled = true;
    const compliance = {'clientId': this.organisationDetails.organisationVO.clientId};
    this.subscriptions.add(this.clientHeaderService.initiateComplianceWorkflow(compliance).subscribe(
      value => {
        if (value.flagResult) {
          this.sidebarTasksService.loadTasks();
          this.taskService.sendMessage('updateActiveWorkFlow');
          this.callSnackBarService(value, 'Compliance check initiated. . .', '');
          this.complianceCheckEnabled = false;
        }
      }
    ));
  }

  openOffboardClientDialog() {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(OffboardClientComponent, config);
    this.dialogRef.componentInstance.organisationDetails = this.organisationDetails;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      if (result.flagResult) {
        // @todo not a client anymore >> add updateDetailsPostOffBoarding function.
      }
    });
  }

  /**
   * Admin-only archival of the entity currently being viewed. Reuses the same
   * archival confirmation dialog as the admin archival management screen, so the
   * backend flow (archive to JSON, remove entity + dependencies, unregister from
   * continuous screening) stays identical.
   */
  openArchivalConfirmDialog() {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(ArchivalConfirmComponent, config);
    this.dialogRef.componentInstance.argMultipleArchival = false;
    this.dialogRef.componentInstance.argEntityId = this.organisationDetails.organisationVO.entityId;
    // Remove the full entity (client + organisation + dependencies). The backend
    // refuses the removal if it would still affect related entities.
    this.dialogRef.componentInstance.argDeleteClientOnly = false;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      if (result) {
        this.router.navigate(['/dashboard']);
      }
    });
  }

  openRiskProfileDialog() {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(RiskProfileComponent, config);
    this.dialogRef.componentInstance.clientId = this.organisationDetails.clientVO.id;
    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // update risk score & class in client header (e.g. 'chip' color).
        this.organisationDetails.clientVO.riskClass = result['riskClass'];
        this.organisationDetails.clientVO.riskScore = result['riskScore'];
      }
    });
  }

  onboardClient(clientType) {
    const onBoardRequestModel = new OnBoardRequestModel();
    this.confirmationService.confirm({
      message: 'You are about to initiate the onboarding process for this organisation,' +
        'are you sure you want to continue?',
      accept: () => {
        onBoardRequestModel.orgId = this.organisationDetails.organisationVO.id;
        if (clientType.toLowerCase() === 'wtt') {
          onBoardRequestModel.workflowType = WorkflowType.WF_ONBOARD_WTT;
        } else {
          onBoardRequestModel.workflowType = WorkflowType.WF_ONBOARD_WWFT;
        }
        this.clientHeaderService.updateOnboardClient(onBoardRequestModel)
          .subscribe(response => {
            this.updateDetailsPostOnboarding(response);
            this.trackingService
              .emitEvent(
                (clientType.toLowerCase() === 'wtt') ?
                  TrackingConstants.ONBOARD_WTT_CLIENT_UPDATE :
                  TrackingConstants.ONBOARD_WWFT_CLIENT_UPDATE,
                (clientType.toLowerCase() === 'wtt') ?
                  TrackingConstants.PERFORM_ONBOARD_WTT_CLIENT_UPDATE :
                  TrackingConstants.PERFORM_ONBOARD_WWFT_CLIENT_UPDATE,
                TrackingConstants.SUCCESS, 1);
            if (response.orgVO) {
              response.flagResult = true;
            }
            this.callSnackBarService(response,
              (clientType.toLowerCase() === 'wtt') ?
                MessageService.ONBOARD_WTT_CLIENT_SUCCESS :
                MessageService.ONBOARD_WWFT_CLIENT_SUCCESS,
              (clientType.toLowerCase() === 'wtt') ?
                MessageService.ONBOARD_WTT_CLIENT_FAILURE :
                MessageService.ONBOARD_WWFT_CLIENT_FAILURE
            );
          }, err => {
            this.trackingService
              .emitEvent(
                TrackingConstants.TASK_GUIDE_TEXT_UPDATE,
                TrackingConstants.PERFORM_TASK_GUIDE_TEXT_UPDATE,
                TrackingConstants.FAILURE, 0);
            this.callSnackBarService(err,
              (clientType.toLowerCase() === 'wtt') ?
                MessageService.ONBOARD_WTT_CLIENT_SUCCESS :
                MessageService.ONBOARD_WWFT_CLIENT_SUCCESS,
              (clientType.toLowerCase() === 'wtt') ?
                MessageService.ONBOARD_WTT_CLIENT_FAILURE :
                MessageService.ONBOARD_WWFT_CLIENT_FAILURE
            );
          }
          );
      }
    });
  }

  openSystemDivisionDialog() {
    this.clientHeaderService.listSystemDivisions().subscribe(
      response => {
        if (response.length) {
          this.systemDivisions = response;
          const config = new MdDialogConfig();
          config.disableClose = true;
          config.viewContainerRef = this.viewContainerRef;

          this.dialogRef = this.dialog.open(SystemDivisionComponent, config);
          this.dialogRef.componentInstance.systemDivisions = this.systemDivisions;
          this.dialogRef.componentInstance.clientId = this.organisationDetails.clientVO.id;
          this.dialogRef.afterClosed().subscribe(() => {
            this.dialogRef = null;
          });
        } else {
          this.callSnackBarService(response,
            MessageService.FETCH_SYSTEM_DIVISION_SUCCESS,
            MessageService.FETCH_SYSTEM_DIVISION_FAILURE);
        }
      },
      err => {
        this.callSnackBarService(err,
          MessageService.FETCH_SYSTEM_DIVISION_SUCCESS,
          MessageService.FETCH_SYSTEM_DIVISION_FAILURE);
      }
    );
  }

  // helpers

  callSnackBarService(response: any, successMsg: string, failureMsg: string) {
    this.snackBarService.showStatus(response, successMsg, failureMsg);
  }

  getStockExchangeName(value: number): string {
    return this.stockExchangeValues.find(appValue => appValue.id === value).name;
  }

  /**
   * Converts a date value (Date or string) to a Date object.
   * Returns null if the input is null/undefined/empty.
   */
  private toDate(dateValue: Date | string | null | undefined): Date | null {
    if (!dateValue) {
      return null;
    }
    if (dateValue instanceof Date) {
      return dateValue;
    }
    return new Date(dateValue);
  }

  formatDate(dateField) {
    return formatDisplayDate(dateField);
  }

  printOrgData() {
    window.open(ConstantsService.APP_BE_URL + ConstantsService.PRINT_REPORT_SERVLET
      + '?reportContext=orgDetails&entityId='
      + this.organisationDetails.organisationVO.id // >> shouldn't this be .entityId?
      + '&fileName=' + this.organisationDetails.organisationVO.name
      , '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
  }

  updateEntityLogo() {
    const config = new MdDialogConfig();
    config.disableClose = true;
    config.viewContainerRef = this.viewContainerRef;

    this.dialogRef = this.dialog.open(UploadLogoComponent, config);
    this.dialogRef.componentInstance.entityId = this.organisationDetails.organisationVO.entityId;
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = null;
      if (result) {
        this.updateLogo(result);
      }
    });
  }

  onClientReview() {
    this.clientReviewEnabled = true;
    const clientReview = {'clientId': this.organisationDetails.organisationVO.clientId};
    this.subscriptions.add(this.clientHeaderService.initiateClientReview(clientReview).subscribe(
      value => {
        if(value.flagResult) {
          this.sidebarTasksService.loadTasks();
          this.taskService.sendMessage('updateActiveWorkFlow');
          this.callSnackBarService(value, 'Client review initiated. . .', '');
          this.clientReviewEnabled = false;
        }
      }
    ));
  }

  updateLogo(result) {
    this.orgLogo = result;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  notDnb() {
    return !this.authenticationGuard.isDnbUser();
  }
}



// WEBPACK FOOTER //
// ./src/app/clients/client/header/client-header.component.ts